import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppTheme } from '../../models/layout.model';
import { DEFAULT_THEME, THEMES } from '@theme/themes';
import { OrganizationContextService } from '@core/services/organization-context.service';
import { LocationContextService } from '@core/services/location-context.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  standalone: false,
})
export class NavbarComponent {
  private readonly router = inject(Router);
  private readonly organization = toSignal(inject(OrganizationContextService).organization$, { initialValue: null });

  private readonly locationContext = inject(LocationContextService);
  readonly locations = toSignal(this.locationContext.locations$, { initialValue: [] });
  readonly selectedLocation = toSignal(this.locationContext.selected$, { initialValue: null });

  @Input() currentDate: Date = new Date();
  @Input() activeTheme: AppTheme = DEFAULT_THEME;
  @Input() userName: string = 'User';
  @Input() userRole: string = 'Staff';
  @Input() userAvatar?: string;

  @Output() menuToggle = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();
  @Output() themeChange = new EventEmitter<AppTheme>();
  @Output() profileClick = new EventEmitter<void>();
  @Output() settingsClick = new EventEmitter<void>();

  readonly themes = THEMES;

  readonly quickActions = [
    { label: 'New Patient', value: '/patients' },
    { label: 'New Appointment', value: '/appointments' },
    { label: 'New OPD Bill', value: '/billing/new' },
  ];

  get organizationName(): string {
    return this.organization()?.name || 'Hospital';
  }

  get organizationCode(): string {
    return this.organization()?.code || '';
  }

  onQuickAction(route: string): void {
    void this.router.navigateByUrl(route);
  }

  onLocationSelect(id: string): void {
    this.locationContext.select(id);
  }

  onThemeSelect(value: string): void {
    this.themeChange.emit((value || DEFAULT_THEME) as AppTheme);
  }

  onProfileClick(): void {
    this.profileClick.emit();
  }

  onSettingsClick(): void {
    this.settingsClick.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }
}
